<template>
  <el-container>

    
  </el-container>
</template>

<script>
  import https from '@/https.js';
  import Base64 from '@/api/video/lib/base64.js';
  import alioss from '@/api/video/ali-oss.js';
  import AliyunUpload from 'aliyun-upload-vod';
  import Crypto from 'crypto-js';
  import OSS from 'ali-oss';
  import validate from '@/api/validate.js';
  // import DndList from '@/components/DndList';
  // import TinymceEditor from '@/components/tinymce-editor/TEditor.vue';
  // import FileUpload from '@/components/FileUpload/FileUpload.vue';
  // import AliPlayer from '@/components/AliPlayer/AliPlayer.vue';
  // import addVideo from '@/js/components/addVideo';
  // import addRadio from '@/js/components/addRadio';
  // import addTast from '@/js/components/addTast';
  // import addTest from '@/js/components/addTest';
  // import courseTreeTemplate from '@/js/components/courseTreeTemplate';
  // import courseTree from '@/js/components/courseTree';

  import {dateFormat} from '@/api/utils.js';
  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    [{'header': 1}, {'header': 2}],               // custom button values
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
    [{'direction': 'rtl'}],                         // text direction
    [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
    [{'header': [1, 2, 3, 4, 5, 6, false]}],
    [{'color': []}, {'background': []}],          // dropdown with defaults from theme
    [{'font': []}],
    [{'align': []}],
    ['link', 'image'],
    ['clean']

  ];
  
  export default {
    components: {
      TinymceEditor, dateFormat,DndList,commodityModel, FileUpload,choseCommodity,dateFormat,AliPlayer,addVideo,addRadio,addTast,addTest,courseTreeTemplate,courseTree
  },
  data() {
      //关联作业、测试
      const generateData = _ => {
        const data = [];
        for (let i = 1; i <= 15; i++) {
          data.push({
            key: i,
            label: `学位英语视频 ${i}`
            //disabled: i % 4 === 0
          });
        }
        return data;
      };
      return {
		jindu:0,
        data: generateData(),
        isDisTab: true,//下一步默认不可点击
        preview: false, //区分是否预览
        ui: {
          category1: [],
          category2: [],
          sortcheckList: [],
        },
        form: {
          categoryOne: null,
          categoryTwo: null,
          courseName: ''
        },
        courseId: '',
        courseList: '',
        valueCheck: [], //已选中
        textarea: '', //视频描述
        videoinput: '', //视频名称
        addFlagIndex: "", // 添加目录显示标记
        centerDialogVisible: false,
        pickerOptions: { //时间组件
          disabledDate(time) {
            return time.getTime() <= Date.now();
          },
        },
        radioStatus: '',
        classOptions: [], //班级下拉框菜单
        value: '',
        radio: "0",
        activeName: 'step1',
        specialUrl: '',
        options: [],
        options2: [],
        addCharpetinput: '', //添加章节INPUT值
        editInptIndex: -1, //编辑INPUT框标记
        editInptIndex2: -1, //编辑INPUT框标记
        editInptIndex3: -1, //编辑INPUT框标记
        editName: '', //编辑章input的model值
        courseName: '',
        modelListArr: [], //模块分类
        valueTypeA: '', //所属类目select
        valueTypeB: '',
        checkList: [], //添加步骤checkbox
        checkSortList: [], //添加步骤checkbox
        radioType: '直播',
        valueTimes: [], //直播时间
        valuetime1: '',
        valuetime2: '',
        value: '',
        valueDate: '',
        isDisable: false, // checkbox是否可选初始值为false, 点击保存设置为禁用
        courseNum: '-1', //章节标记控制hover
        addLearnNum: '-1', //添加学习任务标记
        currentStepUrl: '',
        frameheight: 600,
        fileList: [],
        isRelated: '',
        modelType: '',
		
      }

    },
    watch: {
      courseId(v) {
        //console.error(v)
      },
      activeName(val) {
        if (val === 'step1') {
          this.$refs.move.getKnowledgePoints() //刷新目录树数据
          return
        }
        let modelTypeId = val.replace(/[^0-9]/ig, "");
        let url = val + '.html?courseId=' + this.courseId + '&modelType=' + modelTypeId
        // 創建是否最後一步標記

        if (val == this.checkSortList[this.checkSortList.length - 1].key) {
          url += '&tag=end'
        }
        url += '&r=' + Math.random();
        this.currentStepUrl = url
      },
      radio(val) {
        if (val == 1) {
          this.checkList = [];
          this.checkSortList = [];
          this.radioStatus = 1;
        }
      }
    },
    methods: {
      //获取班级下拉菜单列表
      // getClassList() {
      //   let _this = this;
      //   let data = {
      //     "courseId": this.courseId
      //   }
      //   let conn = Connect(
      //     'class/list',
      //     'POST', 
      //     data,
      //     function (res) {
      //       console.log(res)
      //       _this.classOptions = res.data
      //     },
      //     function (err) {
      //       console.log(err)
      //     }
      //   )
      // },
	  doNothing() {},
      // 切换tab保存顺序
	  
      beforeLeave(i) {
        return new Promise((resolve, reject) => {
          if (this.activeName == 'step1') {
            this.$refs.move.saveKnowledgePoints(false)

          }
          resolve();
        })
      },

      //步骤顺序排列
      checkedChange() {
        let oldCheckSortListLen = this.checkSortList.length;
        let arr = [];
        let index = 0;
        this.modelListArr.forEach((item) => {
          index++;
          this.checkList.forEach((checkItem) => {
            if (item.courseModelTypeId === checkItem.courseModelTypeId) {
              item.key = 'step' + index;
              arr.push(item)
            }
          })
        })

        this.activeName = 'step1';
        this.checkSortList = arr;

      },

      //清空input
      clearVal() {
        this.specialUrl = '';
      },

      //获取课程头部信息并反填
      getCourseInfo() {
        let _this = this
        if (!this.courseId) return;
        let data = {
          "courseId": this.courseId
        }
        Connect(
          'course/get',
          'POST',
          data,
          function (res) {
            _this.courseName = res.data.name;
            _this.valueTypeA = res.data.categoryOne;
            _this.selectChange(_this.valueTypeA)
            _this.valueTypeB = res.data.categoryTwo;
            _this.checkSortList = _this.getIdToMap(res.data.modelList);
            _this.checkList = _this.getIdToMap(res.data.modelList);
            _this.isRelated = res.data.isRelated
            _this.radio = res.data.specialLogo
            _this.radioStatus = res.data.specialLogo;
            _this.specialUrl = res.data.specialUrl
          },
          function (err) {
            console.log(err)
          }
        )
      },

      // 根据id匹配对应数据
      getIdToMap(modelList) {
        let arr = [];
        let index = 0;
        this.modelListArr.forEach((item) => {
          index++;
          modelList.forEach((id) => {
            if (item.courseModelTypeId === id) {
              if (item.courseModelTypeId == 1) {
              } else {
                item.key = 'step' + index;
                arr.push(item)
              }

            }
          })
        })
        return arr;
      },


      //所属类目
      getCourseByType() {
		var courseId = this.courseId
        if (courseId) this.isDisable = true;

        let _this = this
        let conn = Connect(
          'courseCategoryInfo/selectListRecursion',
          'GET', {},
          function (res) {
            console.log('课程目录',res)
            _this.options = res.data
            _this.courseId = courseId;
            _this.getModelList()
          },
          function (err) {
            console.log(err)
          }
        )
      },

      // 下拉框数据变更
      selectChange(id) {
        this.valueTypeB = ''
        this.options.forEach((item) => {
          if (item.ccId === id) {
            this.options2 = item.children;
          }
        })
      },
      //获取模块分类
      // getModelList() {
      //   let _this = this
      //   conn = Connect(
      //     'course/getModelList',
      //     'POST', {},
      //     function (res) {
      //       _this.modelListArr = res.data;
      //       _this.modelType = res.data[0].courseModelTypeId;
      //       //获取课程头部信息并反填
      //       _this.getCourseInfo()
      //     },
      //     function (err) {
      //       console.log(err)
      //     }
      //   )
      // },

      // 获取已选中的id
      getCheckedIds() {
        let arr = [];
        this.checkList.forEach((item) => {
          arr.push(item.courseModelTypeId)
        })
        console.log(arr)
        return arr;
      },

      setFrameHeight(_height, _step) {
        var list = this.ui.sortcheckList;
        var s = true;
        if (_height < 600) _height = 600
        for (var i = 0; i < list.length; i++) {
          if (_step == list[i].name) {
            this.ui.sortcheckList[i].height = _height;
            s = false;
            break;
          }
        }
        if (s == true) {
          this.frameheight = _height;
        }
      },
      backparent() {

      },


      goto(_index) {
        var list = this.checkSortList;
        if (this.activeName == 'step1') {
          this.activeName = list[0].key;
        } else {
          for (var i = 0; i < list.length; i++) {
            if (this.activeName == list[i].key) {
              if (i === 0 && _index < 0) {
                this.activeName = 'step1';
              } else {
                this.activeName = list[i + _index].key;

              }
              break;
            }
          }

        }

      },

      // 点击头部编辑按钮
      editCourseInfo() {
        this.isDisable = false
      },
      // 点击头部重置按钮
      resetCourseInfo() {
        this.getCourseInfo();
      },

      // 点击保存头部按钮
      subCourseAdd() {
        let _this = this;
        let arr = [1];
        let modelList = this.checkList;

        modelList.forEach(function (elem) {
          if (elem.courseModelTypeId) {
            arr.push(elem.courseModelTypeId)
          }
        })

        if (this.radio == 1 && this.specialUrl == '') {
          //弹窗提示
          this.$message({
            message: '地址不能为空',
            type: 'warning'
          });
          return false
        }
        if (this.courseName == '') {
          //弹窗提示
          this.$message({
            message: '课程名称不能为空',
            type: 'warning'
          });
          return false

        } else if (this.valueTypeA == '' || this.valueTypeB == '') {
          // this.$message({
          //   message: '类目不能为空。',
          //   type: 'warning'
          // });
          // return false
        }
        let data = {
          // "categoryOne": this.valueTypeA,
          // "categoryTwo": this.valueTypeB,
          "modelList": arr,
          "name": this.courseName,
          "specialLogo": this.radio,
          "specialUrl": this.specialUrl
        }
        if (this.courseId) {
          data.courseId = this.courseId
        }
        conn = Connect(
          'course/add',
          'POST',
          data,
          function (res) {
            if (res.code == 200) {
              _this.courseId = res.data.courseId;
              _this.isDisable = true; //保存后输入框变为禁用
              _this.isShow = false;
              _this.isDisTab = false;
              _this.radioStatus = _this.radio;
              console.log("当前courseId:::" + _this.courseId)
            } else {
              _this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
          },
          function (err) {
            console.log(err)
          }
        )
      },

      // 提交审核
      //submitCourse() {
      sumbitCourse() {
        let _this = this
        conn = Connect(
          'course/submitReview/' + this.courseId,
          'POST', {},
          function (res) {
            _this.goHome()
          },
          function (err) {
            console.log(err)
          }
        )
      },

      // 预览
      previewCourse() {
        let courseId =  this.courseId
        window.open("../kcxq2.html?courseId=" + courseId)
        //window.parent.$('#iframepage').attr("src", "kcxq2.html?courseId="+courseId)
      },

      // 下一步
      nextStep() {
        this.goto(1);
      },

      goHome() {
        this.$confirm('确定要返回首页吗？').then(() => {
          window.parent.$('#iframepage').attr("src", "courses/1.html")
        }).catch(() => { })
      },

      gonewsj() {
        parent.$('.menu-item').eq(1).find('a').addClass('active')
        parent.$('.menu-item').eq(0).next().find('li').hide()
        parent.$('.menu-item').eq(1).next().find('li').show()
        parent.$('.menu-item').eq(1).find('li').eq(4).find('a').addClass('titnow')
      }

    },
    created: function () {
	  var reg = new RegExp("(^|&)" + 'courseId' + "=([^&]*)(&|$)");
	  var courseId = top.window.location.search.substr(1).match(reg);
      console.log(courseId[2])
      if (courseId) this.isDisable = true;
      this.courseId = courseId[2];
    }
    
  };
</script>
<style>
@font-face {
  font-family: 'iconfont12';  /* Project id 1200137 */
  src: url('//at.alicdn.com/t/font_1200137_hwygidwwfso.woff2?t=1634021564214') format('woff2'),
       url('//at.alicdn.com/t/font_1200137_hwygidwwfso.woff?t=1634021564214') format('woff'),
       url('//at.alicdn.com/t/font_1200137_hwygidwwfso.ttf?t=1634021564214') format('truetype');
}
.iconfont12 {
  font-family: "iconfont12" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.iconwendang1:before {
  content: "\e6e9";
}
.icona-wangye2:before {
  content: "\e6e8";
}
.icontaolun1:before {
  content: "\e6e7";
}
.iconceshi:before {
  content: "\e6e6";
}
.iconlubo1:before {
  content: "\e6e5";
}
.iconzhibo1:before {
  content: "\e6e4";
}
.iconwenben:before {
  content: "\e6e3";
}
.iconyinpin1:before {
  content: "\e6e2";
}
.iconyuandian:before {
  content: "\e6e1";
}
.iconjiantou1:before {
  content: "\e6e0";
}
.iconxiangyou1:before {
  content: "\e602";
}
._point {
			cursor: pointer;
		}
/* ._point > div {
	cursor: text;
} */
._nopoint {
	cursor: text;
	color: #ccc;
}
.taskbox span{
	margin-left: 45px;
}
.courselist-item2{
	    background: #fff;
	    border-bottom: 1px dashed #ccc;
	    height: 46px;
	    line-height: 46px;
	    width: 97%;
	    margin: 0 auto;
	    margin-top: 14px;
}
.el-transfer-panel__item{
	display: block;
}
.el-upload-list__item-name{
	overflow: inherit;
	display: inline-block;
}
.el-upload-list__item .el-icon-close{
	position: revert;
}
.el-upload-list__item .el-icon-close-tip{
	position: revert;
}
.el-upload-list__item-status-label{
	position: revert;
}
.dialog-footer .el-button--small, .el-button--small.is-round {
    padding: 13px 20px;
}
.select-box{
	border: 1px solid lightgrey;
	border-radius: 10px;
	padding: 20px;
	margin: 20px;
	cursor: pointer;
}
.select-box-title{
	font-size: 24px;
	color: #0066FF;
}
.select-box:hover{
	background-color: #0066FF;
	color: white;
}
.select-box:hover .select-box-title{
	color: white;
}
.el-transfer-panel {
      width: 315px;
    }

    .el-message-box {
      width: 630px;
    }
	.courselist-moudl{
		user-select:none
	}
</style>
